<!-- Page Content -->
<div class="page-content faq_section">

    <app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>

    <div class="card">
        <div class="card-header">
            <h5> {{"PROFILE.UPDATE" | translate}} </h5>
        </div>
        <div class="card-body">
            <form method="post" name="enq" [formGroup]="ProfileForm" (ngSubmit)="onSubmit()">
                <div class="row">

                    <div class="form-group col-md-12">
                        <label>{{"PROFILE.USERIMAGE" | translate}}<span class="required">*</span></label>

                        <!-- Hidden input for uploading image -->
                        <input #fileInput type="file" hidden accept="image/*" (change)="onFileSelected($event)" />

                        <!-- Clickable image -->
                        <img [src]="previewUrl || 'images/download.png'" alt="Profile Preview" width="120" height="120"
                            class="mt-2" style="border-radius: 50%; cursor: pointer; display: block;"
                            (click)="triggerImageUpload()" />
                    </div>


                    <label> {{"PROFILE.FIRSTNAME" | translate}} <span class="required">*</span></label>
                    <div class="form-group col-md-12">
                        <input type="text" formControlName="FirstName" class="form-control" name="FirstName">
                        <!-- <button type="button" class="rts-btn bg-primary w-auto text-light profile-btn"
                            (click)="changeFirstName()">
                            {{"PROFILE.CHANGE" | translate}}
                        </button> -->
                    </div>


                    <label> {{"PROFILE.LASTNAME" | translate}}<span class="required">*</span></label>
                    <div class="form-group col-md-12">
                        <input type="text" formControlName="LastName" class="form-control" name="LastName">
                        <!-- <button type="button" class="rts-btn bg-primary w-auto text-light profile-btn"
                            (click)="changeLastName()">
                            {{"PROFILE.CHANGE" | translate}}
                        </button> -->
                    </div>

                    <div class="form-group col-md-12">
                        <label>{{"PROFILE.USERNAME" | translate}}<span class="required">*</span></label>
                        <input type="text" formControlName="Username" class="form-control" name="Username">
                        <div class="text-danger col-12" *ngIf="f['Username'].touched && f['Username'].invalid">
                            <div *ngIf="f['Username'].errors?.['pattern']">
                                {{ "REGISTER.USERNAMEPATTERN" | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label> {{"PROFILE.EMAIL" | translate}} <span class="required">*</span></label>
                        <div class="d-flex g-10">
                            <input type="text" formControlName="Email" class="form-control" name="Email"
                                [disabled]="true">
                            <button type="button" data-bs-toggle="modal" data-bs-target="#changeEmail"
                                class="rts-btn bg-primary w-auto text-light profile-btn">
                                {{"PROFILE.CHANGE_EMAIL" | translate}}
                            </button>
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label> {{"PROFILE.IDNUMBER" | translate}}<span class="required">*</span></label>
                        <input type="number" formControlName="IdNumber" class="form-control" name="IdNumber"
                            [disabled]="true">
                    </div>
                    <div class="form-group col-md-12">
                        <label> {{"PROFILE.PHONENUMBER" | translate}}<span class="required">*</span></label>
                        <input type="text" formControlName="PhoneNumber" class="form-control phone-number"
                            name="PhoneNumber" placeholder="+20XXXXXXXXXX">
                        <small class="text-danger"
                            *ngIf="f['PhoneNumber'].touched && f['PhoneNumber'].errors?.['invalidPhoneCode']">
                            {{ "PROFILE.PHONE_VALIDATION" | translate }}
                        </small>
                    </div>

                    <div class="form-group col-md-12">
                        <label>{{"PROFILE.DATEOFBIRTH" | translate}}<span class="required">*</span></label>
                        <input type="date" formControlName="BirthDate" class="form-control" name="BirthDate">
                    </div>
                    <div class="form-group col-md-12">
                        <label>{{"PROFILE.SPECIALIZATION" | translate}}<span class="required">*</span></label>
                        <input type="text" formControlName="Job" class="form-control" name="Job">
                    </div>
                    <div class="form-group col-md-12">
                        <label>{{"PROFILE.NATIONALITY" | translate}}<span class="required">*</span></label>
                        <!-- <input type="text" formControlName="Nationality"
                                                                class="form-control" name="Nationality"> -->

                        <select formControlName="Nationality" class="form-control fs-5"
                            style="height: 40px; background-color: #f0f1f2">
                            <option value="" disabled selected>{{"PROFILE.CHOOSENATIONALITY" | translate}}</option>
                            <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-12 contact-form-style-2">
                        <button type="submit" class="btn btn-fill-out submit font-weight-bold" name="submit"
                            value="Submit">
                            {{"PROFILE.SUBMIT" | translate}}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Page Content End -->

<app-change-email (emailChanged)="reloadUserData()" [currentEmail]="ProfileForm.get('Email')?.value"></app-change-email>